import request from '../../../helpers/request';

const editMeter = async (formValues) => {
  return await request.put(
    '/RentPlace/meter',
    formValues,
    'При редактировании счетчика произошла ошибка'
  );
};

export default editMeter;
